import { getStudentExamFile, correctStudentExam } from "../../../modules/admin-modules/student-exams/Api";
import { insertAiFeedbackPages } from "./exam-feedback-pdf";

async function fetchExamPdfBytes(filename) {
  const response = await getStudentExamFile(filename);
  return response.data;
}

async function buildFinalPdfFile(snapshot) {
  const sourceBytes = snapshot.annotatedFile
    ? await snapshot.annotatedFile.arrayBuffer()
    : snapshot.studentPdfFilename
      ? await fetchExamPdfBytes(snapshot.studentPdfFilename)
      : null;
  if (!sourceBytes) return null;
  const merged = await insertAiFeedbackPages(sourceBytes, snapshot.feedbackItems, {
    watermark: snapshot.studentName,
    contextLabel: snapshot.feedbackContextLabel,
    studentName: snapshot.studentName,
    examName: snapshot.examName || "Exam",
    awarded: snapshot.scoreTotals?.awarded,
    max: snapshot.scoreTotals?.max,
    hideScore: snapshot.hideScore,
  });
  return new File([merged], snapshot.studentPdfFilename || "exam.pdf", {
    type: "application/pdf",
  });
}

function buildCorrectionFormData(snapshot, pdfFile) {
  const { basePayload, evaluationText, assistantPoints } = snapshot.collected;
  const formData = new FormData();
  formData.append("student_exam_id", basePayload.student_exam_id);
  formData.append("student_id", basePayload.student_id);
  formData.append("assistant_points", assistantPoints);
  if (basePayload.exam_id != null) formData.append("exam_id", basePayload.exam_id);
  if (snapshot.assistant) formData.append("assistant_id", snapshot.assistant);
  if (evaluationText) formData.append("evaluation", evaluationText);
  basePayload.corrections.forEach((correction, index) => {
    formData.append(`corrections[${index}][question_id]`, correction.question_id);
    formData.append(`corrections[${index}][mark]`, correction.mark);
    formData.append(`corrections[${index}][comment]`, correction.comment ?? "");
  });
  formData.append("student_pdf", pdfFile);
  return formData;
}

export async function runCorrectionUpload(snapshot, onStatus) {
  let pdfFile = null;
  if (snapshot.hasPdf) {
    onStatus?.("building");
    pdfFile = await buildFinalPdfFile(snapshot);
    if (!pdfFile) {
      throw new Error("No PDF available to submit.");
    }
  }

  onStatus?.("uploading");
  if (pdfFile) {
    await correctStudentExam({ formData: buildCorrectionFormData(snapshot, pdfFile) });
    return;
  }
  await correctStudentExam(snapshot.collected.basePayload);
}
